var $0212afd59952ac06$exports = {};
$0212afd59952ac06$exports = {
    "invalidSelection": (args, formatter)=>`\u{9009}\u{5B9A}\u{7684} ${formatter.plural(args.selectedCount, {
            one: `\u{4E2A}\u{65E5}\u{671F}`,
            other: `\u{4E2A}\u{65E5}\u{671F}`
        })} \u{4E0D}\u{53EF}\u{7528}\u{3002}`
};


export {$0212afd59952ac06$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
